<template>
  <span class="chip-container" :style="cssVars">
    <span class="chip-label">
      {{ label }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    label: {
      required: true,
    },
    color: {
      required: false,
      default: "blue",
    },
    outlined: {
      default: false,
    },
  },
  computed: {
    cssVars() {
      return {
        "--chip-border-color": this.color,
        "--chip-bg-color": this.outlined ? "#fff" : this.color,
        "--chip-font-color": this.outlined ? this.color : "#fff",
      };
    },
  },
};
</script>

<style scoped>
.chip-container {
  width: fit-content;
  border-radius: 16px;
  height: 24px;
  font-size: 12px;
  background-color: var(--chip-bg-color);
  border-style: solid;
  border-width: 1px;
  border-color: var(--chip-border-color);
  align-items: center;
  cursor: default;
  display: inline-flex;
  line-height: 20px;
  max-width: 100%;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-decoration: none;
  transition-duration: 0.28s;
  transition-property: box-shadow, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
  white-space: nowrap;
  font-family: Roboto;
  margin: 8px;
}
.chip-label {
  color: var(--chip-font-color) !important;
  height: 100%;
  align-items: center;
  display: inline-flex;
}
</style>
